// extracted by mini-css-extract-plugin
export default {"widgetsBoundaries":"WidgetsManager__widgetsBoundaries--uKAw5"};